import { Box, IconButton } from "@mui/material";

import {
  CheckIcon,
  PencilSimpleLineIcon,
  XIcon,
} from "@phosphor-icons/react/dist/ssr";

interface Props {
  isEditing: boolean;
  onEdit: () => void;
  onSave: () => void;
  onCancel: () => void;
}

const LessonPlanActionButtons: React.FC<Props> = ({
  isEditing,
  onEdit,
  onSave,
  onCancel,
}) => {
  return (
    <Box sx={{ display: "flex", gap: 0.5, alignItems: "center" }}>
      {!isEditing ? (
        <IconButton
          aria-label="edit lesson plan"
          onClick={onEdit}
          size="small"
          sx={{
            p: 0.5,
            color: "text.primary",
          }}
        >
          <PencilSimpleLineIcon size={16} weight="fill" />
        </IconButton>
      ) : (
        <>
          <IconButton
            aria-label="save lesson plan"
            onClick={onSave}
            size="small"
            sx={{
              p: 0.5,
              color: "success.main",
            }}
          >
            <CheckIcon size={16} weight="bold" />
          </IconButton>
          <IconButton
            aria-label="cancel editing"
            onClick={onCancel}
            size="small"
            sx={{
              p: 0.5,
              color: "error.main",
            }}
          >
            <XIcon size={16} weight="bold" />
          </IconButton>
        </>
      )}
    </Box>
  );
};

export default LessonPlanActionButtons;